import ConnectedUploadModalContent from './UploadModalContent';

export default ConnectedUploadModalContent;
